import React from 'react';
import { Link } from 'react-router-dom';

const HERO_IMG =
  'https://static.prod-images.emergentagent.com/jobs/8b50f441-6977-4521-a429-f91375c21ad3/images/3ccc8506a42da23421096e57541856eb9d17b65891ec1b066e7caef970a94c56.jpeg';

export default function HeroCarousel() {
  return (
    <section data-testid="hero-carousel" className="relative overflow-hidden">
      <Link
        to="/buy-ticket"
        data-testid="hero-plain-link-0"
        aria-label="R5 a ticket for a R10 000 Lucky Catch — Buy a Ticket"
        className="block cursor-pointer"
      >
        <div className="relative h-[300px] sm:h-[520px] lg:h-[640px]">
          <img
            src={HERO_IMG}
            alt="Golden Fish Lottery — R5 a ticket for a R10 000 Lucky Catch"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
        </div>
      </Link>
    </section>
  );
}
